import styled from "styled-components";
import { PALETTE } from "../commons/Commons.style";
import { BREAKPOINTS } from "../grid";

export const TimelineYearStyle = styled.div`
  font-size: 48px;
  line-height: 55px;
  font-family: Doric News UI;
  overflow-wrap: break-word;

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    font-size: 32px;
    line-height: 36px;
  }
`;

export const TimelineParagraphsContainerStyle = styled.div``;

export const TimelineBottomSection = styled.div`
  margin-top: 32px;
  border-bottom: thin solid ${PALETTE.LIGHT_GREY};
`;

export const TimelineContainerStyle = styled.div`
  padding-top: 8px;

  &:last-child {
    ${TimelineBottomSection} {
      border-bottom: 0;
    }
  }
`;

export const TimelineParagraphAssetContainerStyle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    margin-top: 16px;
  }
`;

export const TimelineHeaderStyle = styled.div`
  border-bottom: thin solid ${PALETTE.LIGHT_GREY};
  padding-bottom: 16px;

  > * {
    font-size: 64px;
    line-height: 77px;

    @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
      font-size: 37px;
      line-height: 48px;
    }
    @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
      font-size: 48px;
      line-height: 48px;
    }
  }
`;
